module.exports = __webpack_public_path__ + "static/media/telegram.894018a5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/telegram.svg
// module id = 641
// module chunks = 8